import { Factory } from 'rosie';

Factory.define('Search').attr('name', 'SEARCH');

Factory.define('SearchWithDefaults').extend('Search');



// WEBPACK FOOTER //
// ./factories/location/search.js